import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useUser } from "~/Context/userContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic } from "@fortawesome/free-solid-svg-icons";
import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
import {
  faThList,
} from "@fortawesome/free-solid-svg-icons";

import { useHistory } from "react-router-dom";

import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import axios from "react-axios";
import dayjs from "dayjs";

import usePlaylistAddForm from "../../Pages/Playlists/usePlaylistAddForm";
import TrackImage from "~/Components/Elements/Global/TrackImage";
import { getCurrentUserPlaylists, postNewPlaylist, postTrackToPlaylist } from "~/api/getCustomPlaylists";
import { getTrack } from "~/api/getTrack";

const initialFormValues = {};

const AddToPlaylistModal = ({ trackId }) => {
  let history = useHistory();
  const { state: userState } = useUser();
  const [loading, setLoading] = useState(false);
  const [loadingLists, setLoadingLists] = useState(true);
  const [track, setTrack] = useState(false);
  const [addedToPlaylist, setAddedToPlaylist] = useState(null);
  const [playlists, setPlaylists] = useState([]);
  const [failure, setFailure] = useState(false);
  const [submitError, setSubmitError] = useState(false);

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setAddedToPlaylist(null);
    setShow(false)
  };
  const handleShow = () => setShow(true);

  const load = async () => {
    await getCurrentUserPlaylists(axios).then((data) => {
      setPlaylists(data.data.playlists);
      setLoadingLists(false);
    });
    await getTrack(axios, trackId).then((data) => {
      const { data: trackObj = {} } = data;
      if (trackObj.id) {
        setTrack(trackObj);
        setLoading(false);
      } else {
        setFailure(true);
      }
    });
  };
  useEffect(() => {
    if (show) {
      load();
    }
  }, [trackId, show]);

  const postPlaylist = async () => {
    setLoading(true);

    const payload = {
      ...inputs,
    };

    try {
      let trackAddedToPlaylistId = null;
      if (payload.playlistName) {
        const resp = await postNewPlaylist(axios, { trackId, playlistName: payload.playlistName });
        const {
          status,
          data: { playlistId },
        } = resp;
        trackAddedToPlaylistId = playlistId;
        // history.push(`/playlist/${playlistId}`);
      } else {
        const resp = await postTrackToPlaylist(axios, { trackId, playlistId: payload.existingPlaylist });
        // history.push(`/playlist/${payload.existingPlaylist}`);
        trackAddedToPlaylistId = payload.existingPlaylist;
      }
      setAddedToPlaylist(trackAddedToPlaylistId);
      setLoading(false);
    } catch (error) {
      console.log("🚀 ~ file AddTpPlaylistModal postPlaylist ~ error:", error)
      setSubmitError(error.response.data.error);
      setLoading(false);
      // onFailure();
    }
  };
  // Needs away to switch handlers one for each button
  const { inputs, handleInputChange, handleSelectChange, handleSubmitTitle, handleSubmitPlaylist, errors } = usePlaylistAddForm(
    initialFormValues,
    postPlaylist
  );

  return (
    <>
      <>
        <span className="icon-add-playlist">
          <div class="addToPlaylist" onClick={handleShow} title="Add track to a Playlist">
            <FontAwesomeIcon icon={faThList} /> <i className="fa fa-list" aria-hidden="true"></i>
            {/* <FontAwesomeIcon icon={faMusic} style={{ fontSize: 20, marginRight: 2 }} /> */}
            {/* <span>Add to Playlist</span> */}
            {/* <span className="plus">+</span> */}
          </div>
          {/* <div>
            <div style={{ marginBottom: 6, textAlign: 'right' }} >
              <Button variant="btn btn-success" onClick={handleShow}>
                <FontAwesomeIcon className="tag-icon" icon={faTag} style={{ marginRight: 6 }} /> Add To Playlist using Modal
              </Button>
            </div>
          </div> */}

          <Modal size="lg" centered show={show} onHide={handleClose}>
            <Modal.Header style={{ backgroundColor: '#ccc' }} closeButton>
              <Modal.Title>
                Add Track To Playlist
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>

              <div>
                {loading ||
                  (loadingLists && (
                    <Col xs={12} sm={{ span: 8, offset: 2 }} className="track-topic-box">
                      <SkeletonTheme color="#fff" highlightColor="#f3f3f3">
                        <Skeleton count={1} />
                      </SkeletonTheme>
                    </Col>
                  )) || (
                    <React.Fragment>
                      <Col xs={12} className="playlist-add-page">
                        <React.Fragment>
                          {(failure && (
                            <center>
                              Sadly this track was not found... but it might be here somewhere. Try the{" "}
                              <Link to={`/search`}>search option</Link>.
                            </center>
                          )) || (

                              <div>
                                <div style={{ margin: "20px 0 40px 0" }}>


                                  <p style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    <FontAwesomeIcon icon="compact-disc" className="compact-disc" />&nbsp;
                                    <span className="trackArtist">
                                      "{track.title}" by {track.artist}
                                    </span></p>
                                </div>

                                {errors.subject && <Alert variant="danger">{errors.subject}</Alert>}
                                {submitError && <Alert variant="danger">Error: {submitError}</Alert>}
                                {addedToPlaylist && (<div>
                                  <h3> ✅ The track was added!</h3>
                                  {/* <p><a href="#" onClick={handleClose}>Close this</a></p> */}
                                  <p><a href="#" onClick={() => {
                                    handleClose();
                                    history.push(`/playlist/${addedToPlaylist}`);
                                  }}>View the Playlist</a></p>
                                </div>) || (<Form
                                  className="totd-form totd-form-horizontal"
                                  noValidate
                                  onSubmit={(e) => {
                                    e.preventDefault();
                                  }}
                                >
                                  <Row className="playlistAddCols">
                                    <Col md={6} xs={12} className="playlistAddCol">
                                      <h4>Add track to a new Playlist</h4>
                                      <Form.Control
                                        name="playlistName"
                                        onChange={handleInputChange}
                                        value={inputs.playlistName || ""}
                                        type="text"
                                        autoComplete="off"
                                        required
                                        className="w-50"
                                        placeholder="Enter a playlist name"
                                        style={{ display: "inline-block", marginRight: 10 }}
                                      />
                                      <Button
                                        disabled={loading}
                                        className="btn-lg"
                                        variant="success"
                                        onClick={(e) => handleSubmitTitle(e)}
                                        type="button"
                                      >
                                        Add
                                      </Button>
                                      {errors.playlistName && <span className="help error">{errors.playlistName}</span>}
                                    </Col>
                                    <Col md={6} xs={12} className="playlistAddCol">
                                      <h4>Add track to an existing Playlist</h4>
                                      <div>
                                        {loadingLists && <div>Loading...</div>}
                                        {!loadingLists && playlists && playlists.length !== 0 && (
                                          <Form.Group controlId="formBasicSelect">
                                            <Form.Control
                                              as="select"
                                              value={inputs.existingPlaylist || ""}
                                              onChange={(e) => handleSelectChange("existingPlaylist", parseInt(e.target.value, 10))}
                                              style={{ display: "inline-block", width: "50%", marginRight: 10, padding: "6px 2px" }}
                                            >
                                              <option value="">Select</option>
                                              {playlists.map(({ id, name }) => (
                                                <option key={id} value={id}>
                                                  {name}
                                                </option>
                                              ))}
                                            </Form.Control>
                                            <Button className="btn-lg" variant="success" onClick={(e) => handleSubmitPlaylist(e)} type="button">
                                              Add
                                            </Button>
                                          </Form.Group>
                                        )}
                                        {!loadingLists && playlists && playlists.length === 0 && <div>No playlists created yet.</div>}
                                      </div>
                                    </Col>
                                  </Row>
                                </Form>)}

                              </div>

                            )}
                        </React.Fragment>
                      </Col>
                    </React.Fragment>
                  )}
              </div>

            </Modal.Body>
          </Modal>


        </span>
      </>

    </>
  )
};

export default AddToPlaylistModal;
